/**
 * Represents the type of order ID to be generated.
 */
export enum OrderIDType {
  /** Represents an Apple Pay Order. */
  ApplePay = 'ApplePay',
  /** Represents a PayPal Order. */
  PayPal = 'PayPal',
  /** Represents an order originating from customer service /a contact center. */
  CustomerService = 'CustomerService',
  /** Represents an order originating from a retail store. */
  Retail = 'Retail',
  /** Represents a default (credit-card), online order. */
  Default = 'Default'
}
